module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Carousel', {
    staticClass: "banner-texts",
    attrs: {
      "autoplay": "",
      "arrow": "never",
      "dots": _vm.bannerTexts && _vm.bannerTexts.length > 1 ? 'inside' : 'none'
    },
    model: {
      value: (_vm.bannerTextIndex),
      callback: function($$v) {
        _vm.bannerTextIndex = $$v
      },
      expression: "bannerTextIndex"
    }
  }, _vm._l((_vm.bannerTexts), function(bannerTextItem) {
    return _c('CarouselItem', {
      key: bannerTextItem.id
    }, [_c('a', {
      staticClass: "banner-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$emit('bannerItemClicked', bannerTextItem.id)
        }
      }
    }, [_vm._v(_vm._s(bannerTextItem.text))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3abcae8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/BannerTexts.vue
// module id = 756
// module chunks = 0